import script from "./AppClientLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./AppClientLayout.vue?vue&type=script&setup=true&lang=js"

export default script